<template>
  <div aria-live="assertive" aria-atomic="true" aria-relevant="text" class="mdl-snackbar mdl-js-snackbar">
    <div class="mdl-snackbar__text"></div>
    <button type="button" class="mdl-snackbar__action"></button>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  methods: {
    init (snackbar) {
      const notification = document.querySelector('.mdl-js-snackbar')
      const data = {
        message: snackbar.message,
        actionHandler: snackbar.actionHandler,
        actionText: snackbar.actionText,
        timeout: 10000
      }
      notification.MaterialSnackbar.showSnackbar(data)
    }
  },
  mounted () {
    this.$snackbar.init = this.init
  }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// index.vue?08a7bf23